import { Box, CircularProgress, Typography } from "@mui/material";
import { useAppSelector } from "../../../../app/hooks";
import Styles from "./S3_IRPurchaseHistory.module.scss";
import {
  getMBorGBFromBytes,
  getResolutionDetails,
} from "../../../../utils/commonFunctions";
import CachedOutlinedIcon from "@mui/icons-material/CachedOutlined";

const T3_IRDataUsage = (props: any) => {
  const {
    usage_title,
    data_usage,
    voice_usage,
    sms_usage,
    mms_usage,
    slash,
    refresh_icon,
  } = props.content;
  const { data, packId, handleDataUsage } = props;
  const { vertical_line } = Styles;
  const { getPackDataUsage, getPackDataUsageError, getPackDataUsagePending } =
    useAppSelector((state) => state.services);
  const { mobile } = getResolutionDetails();

  return (
    <Box
      sx={{
        px: "25px",
      }}
    >
      <Typography
        component="div"
        sx={{
          fontFamily: "var(--font_family_Medium)",
          fontWeight: "var(--font_weight_2)",
          color: "var(--text_color)",
          textAlign: "center",
          mb: "10px",
          p: "10px 40px",
        }}
        onClick={() => handleDataUsage(data)}
      >
        {usage_title}
        {refresh_icon && (
          // <Box
          //   component="img"
          //   alt={refresh_icon?.data.attributes?.alternativeText || ""}
          //   src={refresh_icon?.data.attributes?.url || ""}
          //   ml="10px"
          //   position="relative"
          //   top="2px"
          //   sx={{
          //     cursor: "pointer",
          //     width: "18px",
          //     height: "18px",
          //   }}
          //   onClick={() => handleDataUsage(data)}
          // />
          <CachedOutlinedIcon
            sx={{
              color: "var(--primary_color)",
              width: "18px",
              height: "18px",
              marginLeft: "5px",
              cursor: "pointer",
              ml: "10px",
              position: "relative",
              top: "2px",
            }}
            onClick={() => handleDataUsage(data)}
          />
        )}
      </Typography>

      <>
        {getPackDataUsagePending && data.id === packId ? (
          <Box
            sx={{
              textAlign: "center",
              mb: "30px",
            }}
          >
            <CircularProgress
              sx={{
                color: "var(--text_color)",
              }}
              style={{
                width: "25px",
                height: "25px",
              }}
            />
          </Box>
        ) : (
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: "30px",
              px: "40px",
              flexDirection: { xs: "column", md: "row" },
            }}
          >
            <Box
              sx={{
                fontFamily: "var(--font_family_Medium)",
                fontWeight: "var(--font_weight_0)",
                fontSize: "14px",
                color: "var(--text_color)",
                display: "flex",
                mb: { xs: "10px", md: 0 },
              }}
            >
              <Box sx={{ pb: "5px" }}>{data_usage} </Box>
              {(getPackDataUsage?.dataUsage?.international ||
                getPackDataUsage?.dataUsage?.international === 0) &&
              data.id === packId ? (
                <Box
                  sx={{
                    fontWeight: "var(--font_weight_2)",
                    mb: { xs: "10px", md: 0 },
                  }}
                >
                  <Box
                    component="span"
                    sx={{
                      fontFamily: "var(--font_family_Medium)",
                      fontWeight: "var(--font_weight_2)",
                      fontSize: "16px",
                      color: "var(--primary_color)",
                      margin: "-2px 0px 0px 5px",
                    }}
                  >
                    {getPackDataUsage?.dataUsage?.international === 0
                      ? parseInt(
                          getMBorGBFromBytes(
                            getPackDataUsage?.dataUsage?.international
                          )
                        )
                      : getMBorGBFromBytes(
                          getPackDataUsage?.dataUsage?.international
                        )}
                    {slash}
                  </Box>
                  <Box
                    component="span"
                    sx={{
                      fontFamily: "var(--font_family_Medium)",
                      fontWeight: "var(--font_weight_0)",
                      fontSize: "16px",
                      color: "var(--primary_color)",
                    }}
                  >
                    {data.totalDataGB}
                  </Box>
                </Box>
              ) : (
                "-"
              )}
            </Box>
            {!mobile ? <Box className={vertical_line}></Box> : null}
            <Box
              sx={{
                fontFamily: "var(--font_family_Medium)",
                fontWeight: "var(--font_weight_0)",
                fontSize: "14px",
                color: "var(--text_color)",
                display: "flex",
                mb: { xs: "10px", md: 0 },
              }}
            >
              <Box sx={{ pb: "5px" }}>{voice_usage}</Box>
              {(getPackDataUsage?.voiceMinutes?.international ||
                getPackDataUsage?.voiceMinutes?.international === 0) &&
              data.id === packId ? (
                <Box
                  sx={{
                    fontWeight: "var(--font_weight_2)",
                  }}
                >
                  <Box
                    component="span"
                    sx={{
                      fontFamily: "var(--font_family_Medium)",
                      fontWeight: "var(--font_weight_2)",
                      fontSize: "16px",
                      color: "var(--primary_color)",
                      margin: "-2px 0px 0px 5px",
                    }}
                  >
                    {getPackDataUsage?.voiceMinutes?.international}
                    {slash}
                  </Box>
                  <Box
                    component="span"
                    sx={{
                      fontFamily: "var(--font_family_Medium)",
                      fontWeight: "var(--font_weight_0)",
                      fontSize: "16px",
                      color: "var(--primary_color)",
                    }}
                  >
                    {data.voiceMins}
                  </Box>
                </Box>
              ) : (
                "-"
              )}
            </Box>
            {!mobile ? <Box className={vertical_line}></Box> : null}
            <Box
              sx={{
                fontFamily: "var(--font_family_Medium)",
                fontWeight: "var(--font_weight_0)",
                fontSize: "14px",
                color: "var(--text_color)",
                display: "flex",
                mb: { xs: "10px", md: 0 },
              }}
            >
              <Box sx={{ pb: "5px" }}>{sms_usage}</Box>
              {(getPackDataUsage?.sms?.international ||
                getPackDataUsage?.sms?.international === 0) &&
              data.id === packId ? (
                <Box
                  sx={{
                    fontWeight: "var(--font_weight_2)",
                  }}
                >
                  <Box
                    component="span"
                    sx={{
                      fontFamily: "var(--font_family_Medium)",
                      fontWeight: "var(--font_weight_2)",
                      fontSize: "16px",
                      color: "var(--primary_color)",
                      margin: "-2px 0px 0px 5px",
                    }}
                  >
                    {getPackDataUsage?.sms?.international}
                    {slash}
                  </Box>
                  <Box
                    component="span"
                    sx={{
                      fontFamily: "var(--font_family_Medium)",
                      fontWeight: "var(--font_weight_0)",
                      fontSize: "16px",
                      color: "var(--primary_color)",
                    }}
                  >
                    {data.sms}
                  </Box>
                </Box>
              ) : (
                "-"
              )}
            </Box>
            {!mobile ? <Box className={vertical_line}></Box> : null}
            <Box
              sx={{
                fontFamily: "var(--font_family_Medium)",
                fontWeight: "var(--font_weight_0)",
                fontSize: "14px",
                color: "var(--text_color)",
                display: "flex",
                mb: { xs: "10px", md: 0 },
              }}
            >
              <Box sx={{ pb: "5px" }}>{mms_usage}</Box>
              {(getPackDataUsage?.mms?.international ||
                getPackDataUsage?.mms?.international === 0) &&
              data.id === packId ? (
                <Box
                  sx={{
                    fontWeight: "var(--font_weight_2)",
                  }}
                >
                  <Box
                    component="span"
                    sx={{
                      fontFamily: "var(--font_family_Medium)",
                      fontWeight: "var(--font_weight_2)",
                      fontSize: "16px",
                      color: "var(--primary_color)",
                      margin: "-2px 0px 0px 5px",
                    }}
                  >
                    {getPackDataUsage?.mms?.international}
                    {slash}
                  </Box>
                  <Box
                    component="span"
                    sx={{
                      fontFamily: "var(--font_family_Medium)",
                      fontWeight: "var(--font_weight_0)",
                      fontSize: "16px",
                      color: "var(--primary_color)",
                    }}
                  >
                    {data.mms}
                  </Box>
                </Box>
              ) : (
                "-"
              )}
            </Box>
          </Box>
        )}
      </>
    </Box>
  );
};

export default T3_IRDataUsage;
